var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBfaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BFA-logo_svg__clip0_2093_13370)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6 48.066a1.123 1.123 0 01-1.138-1.126c0-.629.502-1.125 1.138-1.125.636 0 1.138.496 1.138 1.126 0 .595-.502 1.092-1.138 1.125z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.108 44.788l-.703-.231c-.066-.034-.133-.034-.2-.034h-.201a.184.184 0 00-.167.1c-.067.033-.1.1-.1.165-.034.067-.034.133 0 .232.033.066.066.133.1.166.067.033.1.099.167.132l.2.1.57.198.334-.828zm-.502 1.424l-.569-.199c-.066-.033-.133-.033-.167-.033h-.167c-.067 0-.1.034-.168.067-.033.033-.1.099-.1.165a.21.21 0 000 .199c0 .066.034.1.067.165.033.033.1.1.134.1.067.033.1.066.167.066l.536.166.267-.696zm.268 1.656l-1.305-.464a5.451 5.451 0 01-.435-.199 1.484 1.484 0 01-.368-.264.786.786 0 01-.201-.365.843.843 0 01.033-.496c.067-.166.168-.331.335-.43a.99.99 0 01.535-.133c-.1-.066-.2-.133-.267-.199a.717.717 0 01-.168-.265.957.957 0 01-.067-.298c0-.1.034-.232.067-.33.067-.166.134-.299.268-.398.134-.1.268-.166.402-.199.167-.033.3-.033.468 0 .168.033.335.066.469.1l1.439.496-1.205 3.444z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.457 44.325l-.402-.232-.2-.1a.479.479 0 00-.202-.066c-.067 0-.133 0-.2.033a.401.401 0 00-.168.166c-.033.066-.067.132-.067.232 0 .066.034.132.067.198.034.067.1.1.134.166.067.033.134.1.167.132l.469.265.402-.794zm-.1 1.721l-1.205-.728a2.146 2.146 0 01-.436-.331c-.133-.1-.2-.232-.267-.364a.656.656 0 01-.067-.43c.033-.2.067-.365.167-.497.1-.2.301-.365.502-.464.234-.1.469-.066.703 0v-1.788l.836.496-.1 1.656.335.199.77-1.258.702.43-1.94 3.08z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.44 43.43l-.602-.53 2.376-2.78.603.53-2.376 2.78z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.366 40.484l.703.794-.536.464-1.907-2.186.535-.463.703.795 2.242-1.921.536.596-2.276 1.92z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.622 38.1l-.435-.663 3.112-1.953.435.662-3.112 1.953z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 33.596c-.067.1-.067.199-.067.331 0 .1.033.199.067.298.033.066.067.1.1.166a.26.26 0 00.134.132c.034.033.1.066.167.066s.134 0 .168-.033c.1-.033.167-.099.167-.198a.559.559 0 000-.331c0-.133-.033-.265-.033-.43a.936.936 0 010-.431c.033-.133.067-.298.167-.398.1-.132.268-.264.435-.33a1.4 1.4 0 01.535-.1c.168 0 .335.066.469.132.134.067.268.199.402.331.1.133.2.298.267.464.1.199.134.43.168.662 0 .232-.034.464-.1.663l-.804-.265a.874.874 0 00.1-.398c0-.132-.033-.265-.066-.397-.034-.066-.067-.133-.1-.166-.034-.066-.101-.099-.135-.132a.257.257 0 00-.167-.066c-.067 0-.134 0-.167.033-.1.033-.168.132-.201.232-.034.132-.034.231-.034.364 0 .132.034.265.034.43.033.166.033.298 0 .464-.034.132-.067.298-.134.397-.1.133-.234.265-.402.298-.167.066-.334.1-.535.1-.167 0-.335-.067-.469-.133-.133-.066-.267-.198-.401-.331-.1-.132-.2-.298-.268-.43a3.966 3.966 0 01-.167-.597 1.22 1.22 0 01.067-.596l.803.2z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51 31.444l-.167-.795 1.338-.265-.301-1.523-1.339.265-.167-.795 3.614-.728.168.794-1.573.299.3 1.523 1.574-.298.167.794-3.614.729z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.443 19.358l.736-2.351.703.232-.502 1.556.703.232.468-1.457.703.232-.402 1.423 1.372.43-.234.762-3.547-1.06z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__j",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.923 15.384c.134.066.302.133.469.166a.965.965 0 00.435 0c.134-.033.268-.1.401-.199.134-.1.235-.232.302-.364.067-.133.134-.298.167-.464.033-.132 0-.298-.033-.43a1.115 1.115 0 00-.201-.398 1.044 1.044 0 00-.368-.298 2.34 2.34 0 00-.435-.165.965.965 0 00-.435 0c-.134.033-.268.1-.402.199s-.234.231-.301.364a1.904 1.904 0 00-.168.463c-.033.133 0 .298.034.43.033.133.1.266.2.398.068.133.202.232.335.298zm-.435.729a2.35 2.35 0 01-.636-.53 1.775 1.775 0 01-.334-.662 1.787 1.787 0 01-.034-.729c.034-.265.134-.53.268-.761a2.97 2.97 0 01.502-.63c.2-.165.402-.264.636-.364.234-.066.502-.1.736-.066.268.033.536.132.77.265.234.132.435.298.636.53.167.198.267.43.334.662.067.232.067.497.034.728-.034.265-.134.53-.268.762-.134.232-.301.43-.502.63a2.43 2.43 0 01-.636.363 1.86 1.86 0 01-.736.067 2.126 2.126 0 01-.77-.265z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.002 10.881c.1.1.234.199.402.265.133.066.267.1.435.1.133 0 .3-.034.435-.1.134-.066.267-.166.401-.265.1-.1.201-.232.268-.397.067-.133.067-.265.067-.43 0-.133-.034-.299-.1-.431a1.556 1.556 0 00-.302-.398c-.1-.099-.234-.198-.401-.265a.934.934 0 00-.435-.099 1.04 1.04 0 00-.435.1 2.793 2.793 0 00-.402.264c-.1.1-.2.232-.268.398-.067.132-.067.265-.067.43 0 .133.034.298.1.43a.905.905 0 00.302.398zm-.602.596c-.201-.199-.368-.397-.469-.662-.1-.232-.167-.464-.134-.729 0-.232.067-.496.168-.728.1-.232.267-.464.468-.662.2-.2.402-.365.636-.464.234-.1.468-.166.703-.166.234 0 .502.034.736.133.268.1.468.265.67.463.2.2.367.398.468.663.1.231.167.463.134.728 0 .232-.067.497-.168.729-.1.231-.268.463-.468.662-.201.199-.402.364-.636.463-.234.1-.469.166-.703.166-.234 0-.502-.033-.736-.132a2.212 2.212 0 01-.67-.464z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.516 6.344l-.87.563-.402-.596 2.443-1.59.402.597-.87.563 1.64 2.45-.67.43-1.673-2.417z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.092 3.894l.837-.298 1.338 2.02-.066-2.45.702-.265 1.54 2.02-.235-2.45.77-.265.234 3.774-.669.232-1.606-2.119.1 2.649-.67.232-2.275-3.08z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__n",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.053 1.907l2.477-.231.066.728-1.673.166.067.662 1.573-.133.067.729-1.573.132.067.729 1.774-.166.067.729-2.577.231-.335-3.576z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.21 2.9l-.568 1.06.903.1-.334-1.16zm-.2-1.092l.67.066 1.17 3.808-.903-.1-.234-.794-1.406-.165-.401.728-.904-.1 2.008-3.443z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__p",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.394 4.258l.435.166c.067.033.134.033.234.066a.501.501 0 00.234.033c.067 0 .134-.033.201-.066s.1-.132.134-.199c.034-.066.034-.165.034-.231-.034-.067-.034-.133-.1-.166-.034-.033-.101-.1-.168-.132l-.201-.1-.502-.165-.301.794zm-.268-1.688l1.339.463c.167.066.334.133.468.232.134.066.268.199.368.298.1.132.168.265.168.43a.935.935 0 01-.067.53.987.987 0 01-.402.563c-.2.133-.435.166-.67.133l.369 1.755-.904-.332-.234-1.622-.368-.133-.502 1.358-.77-.265 1.205-3.41z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.433 10.219l-1.138.43.603.663.535-1.093zm.569-.96l.435.496-1.673 3.61-.603-.663.368-.761-.97-1.06-.77.298-.602-.662 3.815-1.258z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__r",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.712 14.523c.034-.1.034-.198.034-.33l-.1-.299a.458.458 0 00-.1-.132l-.135-.133c-.067-.033-.1-.066-.167-.066s-.134 0-.167.033c-.1.033-.134.133-.168.232 0 .1 0 .232.034.331l.1.397c.034.133.067.298.067.43 0 .133-.033.299-.1.431-.1.166-.234.265-.368.365a1.02 1.02 0 01-.536.165c-.167 0-.334 0-.468-.066-.168-.066-.301-.166-.435-.265a2.124 2.124 0 01-.335-.43c-.1-.2-.2-.398-.234-.63a1.48 1.48 0 01.033-.662l.837.166c-.067.132-.067.265-.067.397s.033.265.134.397c.033.067.067.1.134.166.033.033.1.1.167.132.067.034.1.034.167.067.067 0 .134 0 .168-.034a.25.25 0 00.167-.231c0-.133 0-.232-.034-.365a8.614 8.614 0 01-.1-.43 1.916 1.916 0 01-.067-.43c0-.133.034-.298.1-.43.067-.166.201-.266.369-.365.167-.1.334-.133.502-.166.167 0 .334.033.468.066.167.067.301.166.435.265.134.133.234.265.335.398.1.165.167.364.234.563.034.198.034.397 0 .596l-.904-.133z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__s",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.352 18.398a.53.53 0 00.1-.299c0-.099 0-.231-.033-.33-.033-.067-.033-.1-.067-.166a.26.26 0 00-.134-.133c-.033-.033-.1-.066-.167-.099h-.2a.3.3 0 00-.202.199c-.033.1-.033.232-.033.33 0 .133 0 .266.033.431 0 .133 0 .298-.033.43-.033.133-.1.266-.2.398a1.273 1.273 0 01-.436.298c-.167.066-.368.1-.535.066-.168-.033-.335-.066-.469-.165-.134-.1-.267-.199-.368-.364-.1-.133-.2-.298-.234-.497-.067-.199-.1-.43-.1-.662 0-.232.066-.43.133-.663l.803.331a.69.69 0 00-.133.365c0 .132 0 .265.033.397a.725.725 0 00.1.166.26.26 0 00.134.132c.034.033.1.066.168.066h.167a.3.3 0 00.2-.198c.034-.1.068-.232.034-.365v-.43c0-.166 0-.298.034-.464.033-.132.1-.265.167-.397a.745.745 0 01.435-.265c.167-.066.335-.1.535-.066.168.033.335.066.469.166.134.099.268.198.368.33.1.133.2.299.234.464.067.199.1.398.1.596 0 .199-.033.398-.1.596l-.803-.198z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__t",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.185 21.543c-.167 0-.334.066-.468.133a1.31 1.31 0 00-.335.265c-.1.099-.167.231-.2.397-.034.165-.068.298-.034.463 0 .166.067.299.134.464a.942.942 0 00.3.331c.135.1.269.166.402.199.168.033.335.033.469.033.167-.033.301-.066.468-.133a.91.91 0 00.335-.264c.1-.1.167-.232.2-.398.034-.165.068-.298.034-.463 0-.166-.067-.298-.134-.464a.941.941 0 00-.3-.331 1.134 1.134 0 00-.402-.199c-.134-.033-.301-.033-.469-.033zm-.1-.828c.268-.033.535-.033.803.067.234.066.468.165.67.33.2.166.334.365.468.564.134.231.2.496.234.761s.034.53-.033.795a2.376 2.376 0 01-.302.662 1.304 1.304 0 01-.569.464 2.074 2.074 0 01-.77.232c-.267.033-.535.033-.802-.067a1.809 1.809 0 01-.67-.33c-.2-.166-.334-.365-.468-.564a2.022 2.022 0 01-.234-.761 2.123 2.123 0 01.033-.795c.067-.232.167-.464.301-.662.134-.199.335-.364.57-.464.233-.1.501-.198.769-.232z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__u",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.089 28.795c.1-.066.2-.166.267-.265.067-.132.1-.265.134-.397.034-.133 0-.298-.033-.43a.787.787 0 00-.201-.365c-.1-.1-.2-.199-.335-.265-.133-.066-.3-.1-.468-.132-.168-.034-.335 0-.469.033-.134.033-.267.1-.401.165-.1.067-.201.166-.268.298-.067.133-.134.265-.134.398a.626.626 0 00.067.43c.067.133.134.265.268.331l-.569.596a1.278 1.278 0 01-.402-.629 1.803 1.803 0 01-.067-.728c.034-.265.1-.53.235-.762.1-.232.267-.43.468-.563.201-.165.402-.265.67-.33.267-.067.535-.1.803-.067.267.033.535.1.77.232.234.132.4.265.568.463.134.199.268.43.301.663.067.264.067.53.034.794 0 .1-.034.199-.067.331-.033.1-.067.232-.134.331l-.2.298c-.068.1-.168.166-.268.232l-.57-.662z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__v",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.49 31.345l-.234.761-3.547-.993.234-.762 3.547.994z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__w",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.947 35.053l-.837-.894-.401.795 1.238.1zm1.104.199l-.3.596-4.017-.166.402-.828.837.067.635-1.258-.569-.597.402-.794 2.61 2.98z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__x",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.274 38.497l.636-.828.568.43-1.74 2.318-.569-.43.636-.828-2.376-1.755.469-.63 2.376 1.723z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.533 41.676l-.569.563-2.576-2.583.569-.563 2.576 2.583z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__z",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.786 42.57c-.1-.133-.201-.265-.335-.331-.134-.1-.268-.133-.402-.166a.965.965 0 00-.435 0c-.167.033-.3.1-.435.199a1.58 1.58 0 00-.334.33c-.067.133-.134.266-.168.398a.639.639 0 00.034.43c.033.166.1.299.2.431.1.133.201.265.335.331.134.1.268.133.402.166a.965.965 0 00.435 0c.167-.033.301-.1.435-.199.134-.1.234-.198.334-.331.067-.132.134-.265.168-.397a.64.64 0 00-.034-.43c-.033-.166-.133-.299-.2-.431zm.702-.464c.168.232.268.464.335.729.067.231.067.496 0 .728a2.382 2.382 0 01-.301.662c-.167.232-.368.398-.57.563a2.103 2.103 0 01-.735.331 1.844 1.844 0 01-.736.034 1.668 1.668 0 01-.67-.265c-.234-.166-.435-.331-.569-.563a2.057 2.057 0 01-.334-.729 1.347 1.347 0 010-.728c.066-.232.167-.464.3-.663.168-.231.369-.397.57-.562a2.1 2.1 0 01.736-.331c.234-.067.502-.067.736-.034.234.034.469.133.67.265.2.133.401.331.568.563z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__A",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.238 46.775l-1.037.364-2.343-1.854.87 2.384-.77.265-1.237-3.41 1.004-.365 2.41 1.888-.904-2.45.77-.266 1.237 3.444z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__B",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.355 35.815l-.369.298-.2-.232.569-.497h.334v1.755h-.368v-1.324h.034z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__C",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.128 35.914c0 .066.034.1.067.132.034.034.1.067.167.067s.1-.033.168-.067a.25.25 0 00.067-.132c0-.066-.034-.1-.067-.133a.257.257 0 00-.168-.066c-.066 0-.1.033-.167.066-.033.034-.067.067-.067.133zm-.033.695c0 .067.033.1.067.166.033.033.1.066.167.066a.257.257 0 00.167-.066.251.251 0 00.067-.166.251.251 0 00-.067-.165.257.257 0 00-.167-.066.257.257 0 00-.167.066.554.554 0 00-.067.165zm-.335-.761c0-.066 0-.133.034-.199.033-.066.066-.1.133-.166l.201-.099c.067-.033.168-.033.234-.033.067 0 .168 0 .235.033.067.033.133.033.2.1.067.033.1.099.134.165a.416.416 0 01.034.199c0 .1-.034.165-.067.232-.067.066-.134.132-.234.132.1.033.167.066.234.166.067.066.1.165.1.264 0 .067 0 .166-.067.232-.033.066-.067.133-.134.166l-.2.1c-.067.032-.168.032-.235.032-.066 0-.167 0-.234-.033l-.2-.1c-.068-.032-.101-.099-.134-.165a.475.475 0 01-.067-.232c0-.099.033-.198.1-.264a.599.599 0 01.234-.166.54.54 0 01-.234-.132c-.034-.067-.067-.133-.067-.232z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__D",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.036 35.98c0 .066.033.133.066.199.067.066.134.066.201.066a.362.362 0 00.201-.066c.067-.066.067-.133.067-.199a.467.467 0 00-.067-.198c-.067-.067-.134-.067-.2-.067a.362.362 0 00-.201.066c-.034.067-.067.133-.067.2zm.3.53h-.133c-.067 0-.167 0-.234-.033s-.134-.066-.168-.133c-.033-.066-.1-.099-.1-.165-.034-.066-.034-.133-.034-.232 0-.1 0-.166.067-.232.034-.066.067-.132.134-.198a.7.7 0 01.201-.133c.067-.033.167-.033.268-.033.1 0 .167 0 .268.033a.702.702 0 01.2.133c.067.066.1.132.134.198a.609.609 0 01.067.232c0 .066 0 .1-.033.166 0 .066-.034.099-.034.132-.033.033-.033.1-.067.133a.25.25 0 00-.067.132l-.401.596h-.469l.402-.596z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__E",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.077 35.914c0 .066.033.1.067.132.033.034.1.067.167.067s.1-.033.167-.067a.25.25 0 00.067-.132c0-.066-.033-.1-.067-.133a.257.257 0 00-.167-.066c-.067 0-.1.033-.167.066-.034.034-.067.067-.067.133zm-.034.695c0 .067.034.1.067.166.034.033.1.066.168.066a.257.257 0 00.167-.066.252.252 0 00.067-.166.252.252 0 00-.067-.165.257.257 0 00-.167-.066.257.257 0 00-.168.066c-.033.066-.067.132-.067.165zm-.334-.761c0-.066 0-.133.033-.199.034-.066.067-.1.134-.166l.2-.099c.068-.033.168-.033.235-.033.067 0 .167 0 .234.033s.134.033.201.1c.067.033.1.099.134.165a.416.416 0 01.034.199c0 .1-.034.165-.067.232-.067.066-.134.132-.235.132.1.033.168.066.235.166.066.066.1.165.1.264 0 .067 0 .166-.067.232-.033.066-.067.133-.134.166l-.2.1c-.068.032-.168.032-.235.032-.067 0-.167 0-.234-.033a369.75 369.75 0 00-.2-.1c-.068-.032-.101-.099-.135-.165-.033-.066-.067-.132-.067-.232 0-.099.034-.198.1-.264a.599.599 0 01.235-.166.54.54 0 01-.234-.132.475.475 0 01-.067-.232z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__F",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.42 28.331h1.973c.168 0 .335-.033.502-.066.168-.033.335-.1.469-.198.134-.1.268-.232.335-.365.1-.165.133-.364.133-.563 0-.198-.066-.397-.167-.596a1.085 1.085 0 00-.435-.33 2.843 2.843 0 00-.569-.166c-.2-.034-.368-.034-.569-.034h-1.64v2.318h-.033zm0-4.205h1.572c.167 0 .335-.033.502-.066.167-.033.301-.1.435-.199a.943.943 0 00.301-.331c.067-.166.134-.331.134-.53a.964.964 0 00-.134-.53c-.1-.132-.2-.231-.335-.33a1.95 1.95 0 00-.468-.166 2.621 2.621 0 00-.535-.067h-1.473v2.22zm-2.21-4.073h3.715c.435 0 .87.033 1.305.1.402.066.803.165 1.171.364.335.198.636.463.837.794.234.398.335.861.335 1.325a1.988 1.988 0 01-.469 1.424c-.334.397-.77.662-1.238.828v.033c.301.033.602.132.904.265.267.132.502.33.702.53.201.231.335.463.435.761.1.298.168.596.168.927.033.464-.1.927-.335 1.358-.234.364-.502.662-.87.86-.368.233-.77.398-1.205.464-.435.1-.87.133-1.338.133H11.21V20.053z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__G",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.786 20.053h6.66v2.086h-4.452v2.053h4.116v2.086h-4.116v3.974H21.82V20.053h-.033z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__H",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.77 23l-1.205 3.18h2.443L34.77 23zm-.837-2.947h1.807l4.317 10.199h-2.476l-.87-2.152h-3.849l-.836 2.152h-2.41l4.317-10.199z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__I",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__I)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.02 13.464c-.034-.033-.067-.067-.134-.1-.034-.033-.1-.033-.168-.033h-.1c-.034 0-.067.033-.1.033-.034 0-.034.033-.067.067-.034.033-.034.066-.034.099s.034.1.067.132c.034.033.1.067.167.067.067.033.134.033.201.066s.134.033.201.1c.067.032.1.098.167.132a.61.61 0 01.067.231c0 .1-.033.166-.067.265a.724.724 0 01-.133.166c-.067.033-.134.1-.201.1-.1.032-.168.032-.268.032s-.2 0-.335-.066c-.1-.033-.2-.1-.267-.166l.267-.298c.034.067.1.1.168.133a.428.428 0 00.2.033h.1c.034 0 .068-.033.101-.033.034 0 .034-.033.067-.066 0-.033.034-.067.034-.067a.25.25 0 00-.067-.132.257.257 0 00-.168-.066c-.067-.033-.134-.033-.2-.066-.067-.034-.134-.034-.201-.1-.067-.033-.1-.1-.168-.132a.608.608 0 01-.066-.232c0-.1.033-.166.067-.232.033-.066.1-.132.133-.165.067-.034.134-.1.201-.1.067-.033.167-.033.268-.033.1 0 .2 0 .301.033.1.033.167.066.268.133l-.301.265z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__J",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.923 13.033h.402v1.755h-.402v-1.755z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__K",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.994 13.033h.536l.736 1.225v-1.225h.401v1.755h-.502l-.77-1.258v1.258h-.4v-1.755z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__L",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.541 13.497c-.033-.033-.1-.066-.134-.1-.067-.033-.134-.033-.2-.033-.067 0-.134 0-.201.034a.586.586 0 00-.168.132c-.033.066-.067.1-.1.166-.034.066-.034.132-.034.231 0 .067 0 .166.034.232s.067.133.1.166c.034.033.1.1.168.132a.429.429 0 00.2.033c.067 0 .134 0 .201-.033a.585.585 0 00.168-.132l.334.232c-.067.099-.167.165-.267.231-.1.033-.235.066-.369.066-.133 0-.267-.033-.368-.066a.79.79 0 01-.3-.198.481.481 0 01-.202-.298 1.69 1.69 0 01-.067-.365c0-.132.034-.264.067-.364a.78.78 0 01.201-.298l.301-.199c.134-.033.268-.066.368-.066h.168c.067 0 .1.033.167.033.067.034.1.034.167.067.034.033.1.066.134.132l-.368.265z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "BFA-logo_svg__M",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51 .02H0v50h51v-50z",
    fill: "#fff"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#BFA-logo_svg__M)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.445 13.033h1.204v.364h-.803v.332h.77v.364h-.77v.364h.87v.364h-1.271v-1.788z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "BFA-logo_svg__clip0_2093_13370"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .02)",
    d: "M0 0h51v50H0z"
  })))));
}

export default SvgBfaLogo;